module.exports = __webpack_public_path__ + "static/media/kj21.7a79bc97.jpg";